
import React, { useState, useEffect } from 'react';
import { TECH_WORDS } from '../services/localData';

const Wordle: React.FC = () => {
  const WORDS_5 = TECH_WORDS.filter(w => w.length === 5);
  const [target, setTarget] = useState("");
  const [guesses, setGuesses] = useState<string[]>([]);
  const [current, setCurrent] = useState("");
  const [status, setStatus] = useState<'playing' | 'won' | 'lost'>('playing');

  useEffect(() => {
    setTarget(WORDS_5[Math.floor(Math.random() * WORDS_5.length)] || "CLOUD");
  }, []);

  const onKey = (key: string) => {
    if (status !== 'playing') return;
    if (key === 'Enter') {
      if (current.length === 5) {
        const nextGuesses = [...guesses, current];
        setGuesses(nextGuesses);
        if (current === target) setStatus('won');
        else if (nextGuesses.length >= 6) setStatus('lost');
        setCurrent("");
      }
    } else if (key === 'Backspace') {
      setCurrent(c => c.slice(0, -1));
    } else if (current.length < 5 && /^[a-zA-Z]$/.test(key)) {
      setCurrent(c => c + key.toUpperCase());
    }
  };

  useEffect(() => {
    const handle = (e: KeyboardEvent) => onKey(e.key);
    window.addEventListener('keydown', handle);
    return () => window.removeEventListener('keydown', handle);
  }, [current, guesses, status]);

  const getStyle = (guess: string, charIdx: number) => {
    const char = guess[charIdx];
    if (char === target[charIdx]) return "bg-green-600 border-green-500 shadow-[0_0_10px_rgba(22,163,74,0.3)]";
    if (target.includes(char)) return "bg-yellow-600 border-yellow-500";
    return "bg-slate-800 border-slate-700";
  };

  return (
    <div className="flex flex-col items-center gap-6 game-transition">
      <div className="grid grid-rows-6 gap-2">
        {Array.from({ length: 6 }).map((_, i) => {
          const guess = guesses[i] || (i === guesses.length ? current : "");
          return (
            <div key={i} className="flex gap-2">
              {Array.from({ length: 5 }).map((_, j) => (
                <div key={j} className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center text-2xl font-black border-2 rounded-lg transition-all duration-500 ${guesses[i] ? getStyle(guess, j) : 'bg-slate-900 border-slate-800'}`}>
                  {guess[j] || ""}
                </div>
              ))}
            </div>
          );
        })}
      </div>
      {status !== 'playing' && (
        <div className="text-center">
          <p className="text-2xl font-black mb-2">{status === 'won' ? "ACCESS GRANTED" : "ENCRYPTION FAILED"}</p>
          <p className="text-slate-400 mb-4">Code was: {target}</p>
          <button onClick={() => window.location.reload()} className="bg-blue-600 px-8 py-2 rounded-full font-bold">REBOOT WORDLE</button>
        </div>
      )}
    </div>
  );
};

export default Wordle;
